import { defineStore } from 'pinia'

export default defineStore({
  id: 'businessDataTable',
  persist: true,
  state: () => {
    return {
      columnState: [],
      isBusinessArchive: false
    }
  },
  actions: {
    setColumnBusinessState: function (payload: any) {
      this.columnState = payload
    },
    setIsBusinessArchive: function (payload: any) {
      this.isBusinessArchive = payload
    }
  },
  getters: {
    getColumnBusinessState: (state: any) => state.columnState,
    getIsBusinessArchive: (state: any) => state.isBusinessArchive
  }
})
